import { render, staticRenderFns } from "./current-variation.vue?vue&type=template&id=0e2235b1"
import script from "./current-variation.vue?vue&type=script&lang=js"
export * from "./current-variation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports